// extracted by mini-css-extract-plugin
export default {"contactUs":"Contact_contactUs__kDmkx","contactDetails":"Contact_contactDetails__MU938","salesText":"Contact_salesText__ASC5A","contactForm":"Contact_contactForm__SwoH-"};